import * as React from "react";
import {observer} from "mobx-react";
import {TableView} from "../../../abstract/TableView";
import {XyiconFeature} from "../../../../../generated/api/base";
import type {UserGroup} from "../../../../../data/models/UserGroup";
import {UserGroupDetailsContent} from "./UserGroupDetailsContent";
import {CreateUserGroupPanel} from "./CreateUserGroupPanel";
@observer
export class UserGroupsView extends React.Component {
	private _headers = [
		{
			id: "name",
			title: "Group Name",
		},
		{
			id: "userIds",
			title: "Number of Users",
		},
		{
			id: "lastModifiedAt",
			title: "Last Updated",
		},
		{
			id: "lastModifiedBy",
			title: "Updated By",
		},
	];

	public override render() {
		return (
			<TableView
				feature={XyiconFeature.UserGroup}
				headers={this._headers}
				create={(onCreated, onCancel, creating) => (
					<CreateUserGroupPanel
						onCancel={onCancel}
						onCreated={onCreated}
						creating={creating}
					/>
				)}
				details={(selected: UserGroup[]) => <UserGroupDetailsContent userGroups={selected} />}
			/>
		);
	}
}
